import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable } from 'rxjs';
import { HttpClient } from '@angular/common/http';
import { Router, NavigationEnd } from '@angular/router';
import { filter } from 'rxjs/operators';
import { Navigation } from '@app/discoverer/app-core';
import { FuseNavigationItem } from '@discoverer/fuse/components/navigation';

const homeAliasRoutes = [
    '/customer-home',
    '/chofcd/completion/home'
];

@Injectable({
    providedIn: 'root'
})
export class NavigationHelper {
    private _navigationSubject: BehaviorSubject<Navigation | null> = new BehaviorSubject<Navigation | null>(null);
    public navigation$: Observable<Navigation | null> = this._navigationSubject.asObservable();

    public currentNavigation: Navigation | null = null;

    constructor(private httpClient: HttpClient, private router: Router) {
        this.router.events
            .pipe(filter(event => event instanceof NavigationEnd))
            .subscribe((event: NavigationEnd) => {
                const currentUrl = event.urlAfterRedirects;
                this.loadNavigation(currentUrl);
            });
    }

    loadNavigation(currentUrl: string): void {
        const apiUrl = 'api/navigation'
        this.httpClient.get<Navigation>(apiUrl).subscribe(
            (navigation) => {
                this.applyHomeActiveState(navigation, currentUrl);
                this._navigationSubject.next(navigation);
                this.currentNavigation = navigation;
            },
            (error) => {
                console.error('Error fetching navigation:', error);
            }
        );
    }

    clearNavigation(): void {
        this._navigationSubject.next(null);
        this.currentNavigation = null;
    }

    private applyHomeActiveState(navigation: Navigation, currentUrl: string): void {
        const normalizedUrl = this.normalizeUrl(currentUrl);
        this.setCommonHomeActiveState(navigation.items || [], homeAliasRoutes.includes(normalizedUrl));
    }

    private setCommonHomeActiveState(items: FuseNavigationItem[], isActive: boolean): void {
        items.forEach(item => {
            if (item.id === 'home' && item.link === '/home') {
                item.active = isActive;
            }

            if (item.children?.length) {
                this.setCommonHomeActiveState(item.children, isActive);
            }
        });
    }

    private normalizeUrl(url: string): string {
        return (url || '').split('?')[0].split('#')[0];
    }
}
